<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <div type="border-card">
                <div class="panel-body">
                    <div class="ibox-content">
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Reward Name
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="giftName" :rules="{
                                    required: false, message: $t('message.required'), trigger: 'change'
                                }">
                                    <el-input :disabled="true" :value="rewardMap[detailInfo.giftId]" show-word-limit
                                        style="width:80%;margin-right:10px;"></el-input>
                                    <el-button type="primary" :disabled="!!$route.query.id" @click="handleSelectGift()">Select
                                        Reward</el-button>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Type
                            </label>
                            <div class="col-sm-4">
                                <el-form-item prop="type" :rules="{
                                    required: false, message: $t('message.required'), trigger: 'change'
                                }">
                                    <el-select :disabled="!!$route.query.id" v-model="detailInfo.type"
                                        v-bind:placeholder='$t("message.PleaseSelect")'>
                                        <el-option v-for="item in typeMap" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Target Warehouse
                            </label>
                            <div class="col-sm-4">
                                <el-form-item prop="type" :rules="{
                                    required: false, message: $t('message.required'), trigger: 'change'
                                }">
                                    <el-select :disabled="!!$route.query.id" v-model="detailInfo.giftStoreId"
                                        v-bind:placeholder='$t("message.PleaseSelect")'>
                                        <el-option :disabled="item.isHq == 0 && item.isPublic == 1 " v-for="item in giftStoreMap" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Quantity
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="inventory">
                                    <el-input-number v-model="detailInfo.inventory" :disabled="!!$route.query.id"
                                        controls-position="right" :max="9999" :min="1"></el-input-number>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Remark
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="remark" :rules="{
                                    required: false, message: $t('message.required'), trigger: 'change'
                                }">
                                    <el-input type="textarea" :disabled="!!$route.query.id" :rows="4"
                                        v-model="detailInfo.remark" show-word-limit>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Redeem Member No.
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="memberNo">
                                    <el-input disabled v-model="detailInfo.memberNo" show-word-limit></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="hr-line-dashed"></div>
                        <div class="form-group">
                            <div class="col-sm-12">
                                <div class="pull-right">
                                    <el-button type="primary" @click="checkEvent()" v-if="(checkPermission('gift_inventory_log_ADD') &&
                                            !$route.query.id)
                                        ">Save</el-button>
                                    <el-button @click="showWarning()">{{
                                        $t("message.Cancel")
                                    }}</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
        <giftInventoryLogSelectModel @add="handleAddGift" @close="handleCloseModel" :isShowAddModel="showGiftModel" />
    </div>
</template>
<script>
import config from "../config";
import giftInventoryLogSelectModel from '../components/giftInventoryLogSelectModel/index.vue'
export default {
    mixins: [config.globalMixin],
    components: {
        giftInventoryLogSelectModel
    },
    data() {
        return {
            detailInfo: {
                giftId: null,
                inventory: 1,
                remark: "",
                type: 1,
                giftStoreId: null,

                id: null,
                giftName: "",
                requestId: null,
                memberNo: null,
            },
            showGiftModel: false,
            giftStoreList: [],
            rewardMap:{}
        };
    },
    computed: {
        _language() {
            return this.$store.state.userInfo.langCode;
        },
        typeMap() {
            return [
                { value: 1, label: "Increase" },
                { value: 2, label: "Reduce" },
                { value: 3, label: "Refund Increase" },
                { value: 4, label: "Request Delivery" }
            ]
        },
        giftStoreMap() {
            return this.giftStoreList.map(i=>{
                return {
                    label:i.storeName,
                    value:i.id,
                    ...i
                }
            })
        }
    },
    watch: {
        detailInfo: {
            handler: function () {
                this.$store.state.edit = true;
            },
            deep: true
        }
    },
    async created() {
        await this.getGiftStoreList()
        await this.getSchoolList()
        await this.init();
        
    },
    mounted() { },
    methods: {
        async init() {
            let id = this.$route.query.id;
            var that = this;
            if (id) {
                let obj = this.getAuthObj();
                obj.id = id;
                obj.apiUrl = this.apiConfig.giftInventoryLogDetail;
                let data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                this.$set(this, "detailInfo", data.data.result);
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            } else {
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            }
        },

        async getSchoolList() {
            let obj = this.getAuthObj();
            const filterParams = {
                name: "",
                pageSize: 9999999,
                pageIndex: 1,
                sortType: "ASC",
                sortField: "sortOrder",
            }
            obj.apiUrl = this.apiConfig.giftList;
            const params = {
                ...obj,
                ...filterParams,
            };
            let data = await this.$store.dispatch("apiEvent", params);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            data.data.result.gifts.forEach(i=>{
                this.rewardMap[i.id] = i.name
            })
        },

        async getGiftStoreList() {
            var objdata = this.getAuthObj();

            objdata.pageIndex = 1;
            objdata.pageSize = 99999;
            objdata.storeName = '';
            objdata.sortName = "storeName";
            objdata.sortType = 'asc';
            objdata.area = '';
            objdata.status = '';

            objdata.apiUrl = this.apiConfig.giftStoreList;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.giftStoreList = data.data.result.giftStoreList;
        },
        handleSelectGift() {
            this.showGiftModel = true
        },
        handleCloseModel() {
            this.showGiftModel = false
        },
        handleAddGift(e) {
            this.detailInfo.giftId = e.id
            this.detailInfo.giftName = e.name
        },
        checkEvent: function () {
            this.$refs["detailInfo"].validate(valid => {
                if (valid) {
                    this.submit();
                } else {
                    this.$toastr.w(this.$i18n.t("message.fillRequired"));
                    return false;
                }
            });
        },
        showWarning(type) {
            var that = this;
            if (!type) {
                that.$router.go(-1);
            } else if (type == 1) {
                this.$store.commit("setwarning", {
                    string: this.$i18n.t("message.deleteContent"),
                    boolean: true,
                    button: [
                        {
                            name: this.$i18n.t("message.Confirm"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                                that.callDelete();
                            }
                        },
                        {
                            name: this.$i18n.t("message.Cancel"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                            }
                        }
                    ]
                });
            }
        },
        async submit() {
            try {
                let obj = this.getAuthObj();
                for (var key in this.detailInfo) {
                    if (key != "userId") obj[key] = this.detailInfo[key];
                }
                var data;
                obj.apiUrl = this.apiConfig.giftInventoryLogCreate;
                data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                if (data.data.status_code === "0") {
                    this.$store.state.edit = false;
                    this.$router.go(-1);
                }
            } catch (err) { }
        },
        Delete() {
            this.showWarning(1);
        },
        async callDelete() {
        },
    }
};
</script>
  